import React from "react";

import PodcastCard from "@/components/PodcastCard";
import { PodcastTilesInterface } from "@/helpers/pageHelpers/Common/interface";
import EmptyState from "@/components/EmptyState";

import styles from "./PodcastTiles.module.scss";

const PodcastTiles: React.FC<PodcastTilesInterface> = ({
  items,
  searchQuery = "",
}) => {
  const noResults = !!!items.length;
  const searched = !!searchQuery.length;

  const podcastCards = items.map(
    ({ id, slug, title, artwork, hosts, followed }, index) => (
      <PodcastCard
        key={id}
        id={id}
        slug={slug}
        title={title}
        picture={artwork}
        hosts={hosts}
        followed={followed}
        index={index}
      />
    )
  );

  if (searched && noResults) {
    return (
      <EmptyState
        className={styles.emptyState}
        subheading="Spróbuj zmienić wpisaną frazę lub sprawdź popularne podcasty."
      />
    );
  }

  return <>{podcastCards}</>;
};

export default PodcastTiles;
